import { Blotter } from 'components/Blotters/Trades/trades-blotter';
import { FC } from 'react';

const TradesBlotter: FC = () => (
  <div className="trades-blotter-route-component page-container w-100 h-100">
    <Blotter />
  </div>
);

export default TradesBlotter;
